import { handleActions } from 'redux-actions';
import {
  setBeneficiarioEditar,
  setIndexBeneficiairoEditar,
  setShowFormActiom,
  setNombresArchivosSubir
} from 'src/reducers/PaginaCompra/actions';
import { handleSetState } from '../utils';

const initialState = {
  showForm: false,

  beneficiario: null,
  indexEditar: 0,
};

export type PaginaCompraStateType = typeof initialState;

const PaginaCompraReducer = handleActions<any, any>(
  {
    [setShowFormActiom as any]: handleSetState('showForm'),
    [setBeneficiarioEditar as any]: (state, { payload }) => ({
      ...state,
      beneficiario: payload,
    }),
    [setIndexBeneficiairoEditar as any]: (state, { payload }) => ({
      ...state,
      indexEditar: payload,
    }),
  },
  initialState,
);

export const NombresArchivosSubir = handleActions<any, any>({ [setNombresArchivosSubir as any]: (state, action) => ([...state, action.payload]), }, []);

export default PaginaCompraReducer;
